import type { Partner, PartnerParameter, PartnerProduct } from '@/types/types'

export const isManualProduct = (product: PartnerProduct): boolean => {
  if (product.type === 'manual') return true
  const partnerId = product.partnerId
  const externalId = String(product.externalId ?? '').trim()
  return externalId.length > 0 && (partnerId == null || partnerId === 0)
}

export const isPartnerLinkedProduct = (product: PartnerProduct): boolean => {
  const partnerId = Number(product.partnerId)
  const externalId = String(product.externalId ?? '').trim()
  return Number.isFinite(partnerId) && partnerId > 0 && externalId.length > 0
}

export const createManualProduct = (externalId: string): PartnerProduct => ({
  externalId,
  name: externalId,
  type: 'manual',
  partnerId: null
})

export const getProductKey = (product: PartnerProduct): string => {
  return isManualProduct(product) ? `manual-${product.externalId}` : `${product.partnerId}-${product.externalId}`
}

export const findProductIndex = (items: PartnerProduct[], product: PartnerProduct): number => {
  return items.findIndex((p) => {
    if (isManualProduct(p) && isManualProduct(product)) {
      return p.externalId.toString() === product.externalId.toString()
    }
    return p.partnerId === product.partnerId && p.externalId.toString() === product.externalId.toString()
  })
}

export const addProductIfNotExists = (items: PartnerProduct[], product: PartnerProduct): boolean => {
  if (findProductIndex(items, product) === -1) {
    items.push(product)
    return true
  }
  return false
}

export const removeProductFromList = (items: PartnerProduct[], product: PartnerProduct): boolean => {
  const index = findProductIndex(items, product)
  if (index !== -1) {
    items.splice(index, 1)
    return true
  }
  return false
}

export const groupPartnerAccounts = (
  partnerAccounts: PartnerParameter[]
): (Partner & { accounts: PartnerParameter[] })[] => {
  return partnerAccounts.reduce<(Partner & { accounts: PartnerParameter[] })[]>((partners, partnerAccount) => {
    const index = partners.findIndex((p) => p.id === partnerAccount.partner.id)
    if (index === -1) {
      partners.push({ ...partnerAccount.partner, accounts: [partnerAccount] })
    } else {
      partners[index].accounts.push(partnerAccount)
    }
    return partners
  }, [])
}

export const initializeQuantities = (
  keys: string[],
  quantities: Record<string, number>
): Record<string, number> | null => {
  const updated = { ...quantities }
  let changed = false
  for (const key of keys) {
    if (!(key in updated)) {
      updated[key] = 1
      changed = true
    }
  }
  return changed ? updated : null
}
